import { render, staticRenderFns } from "./noticeTable.vue?vue&type=template&id=7a46a6e4&"
import script from "./noticeTable.vue?vue&type=script&lang=ts&"
export * from "./noticeTable.vue?vue&type=script&lang=ts&"
import style0 from "./noticeTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports